import React from 'react';

import { formatMoney } from '@betterment/js-runtime';
import { Icon, ListRow, Separator, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { PayrollContributionConfigFragment } from '../../../graphql/fragments/payrollContributionConfig.generated';
import { urlBuilder } from '../../urlBuilder';

type Props = {
  config: PayrollContributionConfigFragment;
};

export const PayrollContributionConfig: React.FC<Props> = ({ config }) => {
  const legalAccountIdValue = getLegalAccountId(config);

  return (
    <>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <ListRow key={config.id}>
        <ListRow.LeadingAsset>
          <Icon name="ArrowCirclePlus" size="small" />
        </ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          {contributionInfo(config)}
          <Text variant="text50" color="text.weak">
            Per Pay Period
          </Text>
        </ListRow.LeadingContent>
        <ListRow.TrailingContent>
          {legalAccountIdValue && (
            <SambaAutoLink
              to={urlBuilder.appDeferralSetting.absolute({
                legalAccountId: legalAccountIdValue,
                return_to: window.location.pathname,
              })}
            >
              Edit
            </SambaAutoLink>
          )}
        </ListRow.TrailingContent>
      </ListRow>
    </>
  );
};

function contributionInfo(config: PayrollContributionConfigFragment) {
  switch (config.value.__typename) {
    case 'PayrollContributionConfigValueAmount':
      return (
        <Text>
          {formatMoney(config.value.amount)} to {config.destinationName}
        </Text>
      );
    case 'PayrollContributionConfigValuePercent':
      return (
        <Text>
          {config.value.percent}% to {config.destinationName}
        </Text>
      );
    default:
      return '';
  }
}

function getLegalAccountId(config: PayrollContributionConfigFragment) {
  if (config.account.__typename === 'ManagedSubAccount') {
    return config.account.legalAccount.legacyId;
  }

  return null;
}
